import teaConst from 'Src/const/tea.js'
import { PromotionTypes } from 'Src/pagelets/promotion/promotion-state.js'
import { hasNoVisibleModal } from './common'
import commonTea from './common-tea.js'
import { getCurTabName } from '../common.js'

export default {
  mixins: [commonTea],
  mounted () {
    this.addShortcuts()
  },
  destroyed () {
    this.removeShortcuts()
  },
  methods: {
    addShortcuts () {
      this.switchTabByShortCut()
      this.handleOpenKeyBoardModalByShortcut()
    },
    removeShortcuts () {
      this.unbindSwitchTabByShortCut()
      window.$shortcut.remove('Alt+shift+/')
    },
    // 通过快捷键切换tab
    switchTabByShortCut () {
      for (let key in PromotionTypes) {
        const { shortcut, router } = PromotionTypes[key] || {}
        window.$shortcut.add(
          shortcut,
          () => {
            const currentRouter = this.$route.name || getCurTabName() // 由于推广管理四个 tab 改为了异步组件，需要等到 tab 挂载完成后才能读取到 name，所以这里初始化时，第一次需要调用  getCruTabName 来获取
            // 重载页面
            if (currentRouter === router) this.reload()
            else this.onChangeActiveTab({ router: router })

            this.switchTabTeaEvent(router, true)
          },
          { preventDefault: true }
        )
      }
    },
    // 取消绑定快捷键切换tab
    unbindSwitchTabByShortCut () {
      for (let key in PromotionTypes) {
        const { shortcut } = PromotionTypes[key] || {}
        window.$shortcut.remove(shortcut)
      }
    },
    // 快捷键打开快捷键说明
    handleOpenKeyBoardModalByShortcut () {
      window.$shortcut.add('Alt+shift+/', () => {
        if (hasNoVisibleModal()) this.handleViewKeyBoardModal(true)
      })
    },
    // 查看快捷键
    handleViewKeyBoardModal (isShortcut) {
      this.keyboardModalVisible = true

      this.viewKeyBoardModalTeaEvent(isShortcut)
    },
    handleCloseKeyBoardModal (isShortcut) {
      this.keyboardModalVisible = false

      this.cancelModal(null, 'explanation', isShortcut === true ? 'shortcut' : 'btn')
    },
    // 切换tab埋点
    switchTabTeaEvent (tab, isShortcut) {
      window.promotionTeaEvent(
        'promotion_index_level_swicth',
        () => {
          return {
            from: isShortcut === true
              ? teaConst.promotion.actionFrom.shortcut
              : teaConst.promotion.actionFrom.btn,
            tab: teaConst.promotion.level[tab]
          }
        },
        teaConst.type.event
      )
    },
    // 查看快捷键弹窗埋点
    viewKeyBoardModalTeaEvent (isShortcut) {
      window.promotionTeaEvent(
        'promotion_index_shotcut_key_click',
        () => {
          return {
            from: isShortcut === true
              ? teaConst.promotion.actionFrom.shortcut
              : teaConst.promotion.actionFrom.btn
          }
        },
        teaConst.type.event
      )
    },
    // 修改预算埋点
    modifyAuditTeaEvent (level) {
      window.promotionTeaEvent(
        'promotion_index_verfied_change',
        () => {
          return {
            level: teaConst.promotion.level[level]
          }
        },
        teaConst.type.event
      )
    }
  }
}
